import React from 'react';

import { useRouterActions } from 'react-resource-router';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';

import { Linked, Unlinked } from '../styled';

type Props = {
  commitUrl: string;
  commitShortHash: string;
  isLink?: boolean;
};

const CommitLink = ({ commitUrl, commitShortHash, isLink }: Props) => {
  const { push } = useRouterActions();
  const enableClientSideLinking = FeatureGates.checkGate(
    StatsigFeatureKeys.enableClientSideLinking
  );
  return isLink ? (
    <Linked
      href={commitUrl}
      target="_top"
      onClick={e => {
        if (enableClientSideLinking) {
          e.preventDefault();
          push(commitUrl);
        }
      }}
    >
      {commitShortHash}
    </Linked>
  ) : (
    <Unlinked>{commitShortHash}</Unlinked>
  );
};

export default React.memo(CommitLink);
